import { Component, OnInit, Inject } from '@angular/core';
import { MeasurementPointReading, ReportConfigVM, Tool, ToolList } from '../../models/rope-shovel.model';
import { RopeShovelService } from '../../rope-shovel.service';
import { NotificationsService } from 'angular2-notifications';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'measurement-points',
  templateUrl: './measurement-points.component.html',
  styleUrls: ['./measurement-points.component.scss']
})
export class MeasurementPointsComponent implements OnInit {
  readings: MeasurementPointReading[] = [];
  inspectionDetailId: number = -1;
  compartMeasurePointId: number = -1;
  firstClose: boolean = true;
  firstToolTypeId: number = -1;
  dataChanged: boolean = false;
  Tool: any = Tool;
  uom: string = "mm";
  PossibleToolList:ToolList[]=[];
  compartType:number;
  reportId:number;
  miningShovelReportId:number;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private _service: RopeShovelService,
    private _notify: NotificationsService,
    private dialogRef: MatDialogRef<MeasurementPointsComponent>) { }

  ngOnInit() {
    this._service.getUserUom().subscribe(uom => this.uom = uom);
    this.readings = this.data.readings;

    //console.log("Reading__", this.readings)
    this.Changemeasurement();
    this.inspectionDetailId = this.data.inspectionDetailId;
    this.reportId=this.data.reportId;
    this.miningShovelReportId=this.data.miningShovelReportId;
    this.compartType= this.data.compartType;
    this.compartMeasurePointId = this.data.compartMeasurePointId;
    this.GetPossibleToolstoMeasurementPoints();
    if (this.readings.length > 0)
      this.firstToolTypeId = this.readings[0].ToolId;
    let sub = this.dialogRef.beforeClosed().subscribe(() => {
      if (this.firstClose) {
        this.firstClose = false;
        if (this.dataChanged)
          this.dialogRef.close({ reading: this.calculateAverageReading(), worn: this.calculateAverageWorn(), readings: this.readings });
      }
      sub.unsubscribe();
    });
  }



  //replace -1 measurement into null

Changemeasurement(){
  this.readings.map(x=>{
    if(x.Measurement == -1 ){
      x.Measurement = null;
    }
  })
}

//chnage Estimate Switch
changetoggleEstimate(r:MeasurementPointReading){
  

  console.log("selectedmeasurement", r)
  if(r.Measurement!=null){
    r.IsEstimate = !r.IsEstimate;
    this._service.updateMeasurementPointEstimate(this.inspectionDetailId, this.compartMeasurePointId,r.Id,r.IsEstimate).subscribe(r => {
      if (r.m_Item1==true) {
         this.dataChanged = true;
         this._notify.success('Saved', r.m_Item2);
       } else {
         this._notify.alert('Couldn\'t Save', r.m_Item2);
         console.log(r.m_Item2);
       }
  
      
     }, err => {
       console.log(err);
       this._notify.alert('Error', 'Unable to update the Estimate. Please contact support for help. ');
     });
  }else{
   // r.IsEstimate = !r.IsEstimate;
    this._notify.alert('Couldn\'t Save', 'Please Enter Measurement');
    return;
  }
  
}


  // This will return true if the measurement should be converted from inches to mm
  // before sending the value to the server.
  // The problem is that because the other tools like YES / NO are stored in the database as 0 / 1,
  // if we converted that to mm because the user has inches then it would store as .0001 or something stupid and
  // wouldn't flow through correctly as a yes / no. The structure in the back end isn't the best for different tool types and
  // storing their readings, so I have to do all these extra ifs everywhere. 
  shouldDoUnitConversion(): boolean {
    if (this.uom == "mm") return false;
    switch (this.firstToolTypeId) {
      case Tool.Calipers:
      case Tool.DepthGuage:
      case Tool.Ruler:
      case Tool.UT:
        return true;
      default:
        return false;
    }
  }

    updateMeasurementPointReading(readingNumber: number, reading: number) {
        if (reading == null) reading = -1;
    this._service.updateMeasurementPointReading(this.inspectionDetailId, this.compartMeasurePointId, readingNumber, this.shouldDoUnitConversion() ? this.convertToMM(reading) : reading).subscribe(r => {
     if (r.m_Item1 != -999) {
        this.dataChanged = true;
        this.readings.find(a => a.Id == readingNumber).WornPercentage = r.m_Item1;
        //this.readings.find(a => a.Id == readingNumber).Measurement = reading;
        this.Changemeasurement();
        this.readings.find(a => a.Id == readingNumber).Measurement = reading;

        const hasMeasurement = this.readings.some(item => item.Measurement != null && item.Measurement !== 0);

            // if (!hasMeasurement) {
                let params = new ReportConfigVM();
                params.Id = this.reportId ;
                params.CompartTypeId = this.compartType;
                params.MiningShovelReportId = this.miningShovelReportId;
                params.OptionType = 'IncludeObservationsTable';
                params.OptionTypeChecked = true;
                params.InspectionId = this.inspectionDetailId;
                //params.SortOrder = SortOrder;
                this._service.SetRSReportMeasurementPointConfig(params).subscribe(res => {
                  if (res) {
                    params.OptionType = 'IncludeGraph';
                    this._service.SetRSReportMeasurementPointConfig(params).subscribe(res => {
                      if (res) {
                      }
                    });
                  }
                });
              // } 
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }

     
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the reading. Please contact support for help. ');
    });
  }

  convertToMM(inchesReading: number): number {
    return inchesReading * 25.4;
  }

  calculateAverageReading() {
    let numberOfReadings = 0;
    let sum = 0;

    switch (this.firstToolTypeId) {
      case Tool.KeeperOrientation:
        return this.getKPO(this.readings[0].Measurement);
      case Tool.Eval:
        return this.getEval(this.readings[0].Measurement);
      case Tool.DriveLugsEngaged:
        return this.readings[0].Measurement;
      case Tool.Observation:
        return this.readings[0].Text;
      case Tool.YESorNO:
        return this.getYesNo(this.readings[0].Measurement);
      case Tool.passFail:
        return this.passFail(this.readings[0].Measurement);
    }

    this.readings.forEach(r => {
      if (r.Measurement > 0) {
        sum = +r.Measurement + +sum;
        numberOfReadings++;
      }
    });
    return (sum / numberOfReadings).toFixed(2);
  }

  calculateAverageWorn() {
    let numberOfReadings = 0;
    let sum = 0;

    this.readings.forEach(r => {
      if (r.ToolId == 5 || r.ToolId == 6 || r.ToolId == 7 || r.ToolId == 8 || r.ToolId == 10) {
        return 0;
      }
      if (r.WornPercentage > 0) {
        sum = +r.WornPercentage + +sum;
        numberOfReadings++;
      }
    });
    return (sum / numberOfReadings).toFixed(2);
  }

  getKPO(reading: number) {
    switch (reading) {
      case 1: return "A";
      case 2: return "B";
      case 3: return "C";
      case 4: return "D";
      default: return "?";
    }
  }

  getEval(reading: number) {
    switch (reading) {
      case 1: return "A";
      case 2: return "B";
      case 3: return "C";
      case 4: return "X";
      default: return "?";
    }
  }
  getYesNo(reading: number) {
    switch (reading) {
      case 1: return "Yes";
      case 0: return "No";
      default: return "?";
    }
  }
  passFail(reading: number) {
    switch (reading) {
      case 1: return "Pass";
      case 0: return "Fail";
      default: return "?";
    }
  }

  GetPossibleToolstoMeasurementPoints(){
    this._service.GetMeasuremenetPointPossibleTools(this.compartMeasurePointId).subscribe(res=>{
      this.PossibleToolList = res;
    })
  }

  
  ToolSelected(event: any, element: MeasurementPointReading) {
    this._service.UpdateToolForMeasurementPoint(this.compartMeasurePointId,element.ToolId, element.Id, this.inspectionDetailId).subscribe(r=>{
      if(r.m_Item1){
        if(element.Measurement !=-1){
          this.updateMeasurementPointReading(element.Id,element.Measurement);
        }
        this._notify.success( r.m_Item2);
      } else {
        this._notify.warn( r.m_Item2);
      }
    });
  }

  onCloseClick(){
    this.dialogRef.close({ reading: this.calculateAverageReading(), worn: this.calculateAverageWorn(), readings: this.readings });
  }

}
